import { render, staticRenderFns } from "./input-loader.vue?vue&type=template&id=142640da&scoped=true"
import script from "./input-loader.vue?vue&type=script&lang=js"
export * from "./input-loader.vue?vue&type=script&lang=js"
import style0 from "./input-loader.vue?vue&type=style&index=0&id=142640da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142640da",
  null
  
)

export default component.exports